import {NumberInput, NumberInputProps} from "@mantine/core";
import React from "react";

export default function DinheiroInput(props: NumberInputProps) {
    return (
        <NumberInput
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            prefix="R$ "
            hideControls
            {...props}
        />
    )
}